import { makeStyles } from "tss-react/mui";

/**
 * Shared layout classes for full-page data tables (devices, files, downloads, admin lists, ...).
 * Centralizing them is what keeps every page's table the same height, with the same internally
 * scrolling body and the same pagination footer pinned to the bottom.
 */
export const useFullPageTableLayoutStyles = makeStyles()(() => ({
    tableLayout: {
        flex: 1,
        minHeight: 0,
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
    },
    tableWrapper: {
        position: "relative",
        flex: 1,
        minHeight: 0,
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
    },
    tableContainer: {
        flex: 1,
        minHeight: 0,
        overflowY: "auto",
        overflowX: "auto",
        overscrollBehavior: "contain",
    },
    tableContainerNoScroll: {
        overflowY: "hidden",
    },
    pagination: {
        flexShrink: 0,
    },
}));
